import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ButtonsModule, ButtonModule } from '@progress/kendo-angular-buttons';
import { DirectorySearchChannelsComponent } from './directory-search-channels.component';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { GridModule } from '@progress/kendo-angular-grid';
import { PipesModule } from '../../pipes/pipes.module';
import { ProviderSearchModule } from 'src/app/shared/provider-search/provider-search.module';
import { Kno2SearchModule } from 'src/app/shared/kno2-search/kno2-search.module';
import { BreadcrumbModule } from 'src/app/shared/breadcrumb/breadcrumb.module';

@NgModule({
  imports: [
    CommonModule,
    DialogsModule,
    PopupModule,
    TranslateModule,
    InputsModule,
    ReactiveFormsModule,
    LayoutModule,
    ButtonModule,
    ButtonsModule,
    DropDownsModule,
    GridModule,
    PipesModule,
    ProviderSearchModule,
    BreadcrumbModule,
    Kno2SearchModule
  ],
  declarations: [DirectorySearchChannelsComponent],
  exports: [DirectorySearchChannelsComponent],
})
export class DirectorySearchChannelsModule { }
